require("core-js/modules/es.array.concat");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.time = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getYMD = getYMD;
  _exports.getUnixTime = getUnixTime;
  _exports.getHoursMin = getHoursMin;

  function getYMD(time) {
    if (!time) {
      return '-';
    }

    if ("".concat(time).length == 10) {
      time = time * 1000;
    }

    var t = new Date(time);
    time = t.getFullYear();
    time += "/".concat(t.getUTCMonth() + 1 > 9 ? t.getUTCMonth() + 1 : '0' + (t.getUTCMonth() + 1));
    time += "/".concat(t.getDate() > 9 ? t.getDate() : '0' + t.getDate());
    time += "   ".concat(t.getHours() > 9 ? t.getHours() : '0' + t.getHours());
    time += ":".concat(t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes());
    time += ":".concat(t.getSeconds() > 9 ? t.getSeconds() : '0' + t.getSeconds());
    return time;
  }

  function getUnixTime() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var y = new Date(time).getFullYear();
    var m = new Date(time).getMonth() + 1;
    var d = new Date(time).getDate();
    return new Date("".concat(y, "-").concat(m, "-").concat(d, " 00:00:00")).getTime();
  }

  function getHoursMin() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var hours = new Date(time).getHours();
    var min = new Date(time).getMinutes();
    return "".concat(hours > 9 ? hours : '0' + hours, ":").concat(min > 9 ? min : '0' + min);
  }
});